import React, { useEffect, useRef, useState } from 'react';

export default function DeveloperPrompt({ text }) {
    const [open, setOpen] = useState(false), [status, setStatus] = useState(''), [manual, setManual] = useState(false);
    const input = useRef(null), currentText = useRef(text);
    currentText.current = text;
    useEffect(() => { setStatus(''); setManual(false); setOpen(false); }, [text]);
    useEffect(() => { if (manual && open && input.current) { input.current.focus(); input.current.select(); } }, [manual, open]);
    if (!text) return null;
    async function copy() {
        try {
            if (!navigator.clipboard?.writeText) throw new Error('clipboard_unavailable');
            await navigator.clipboard.writeText(text);
            if (currentText.current === text) setStatus('Промпт скопирован');
        } catch {
            if (currentText.current !== text) return;
            setOpen(true); setManual(true); setStatus('Текст выделен. Скопируйте его вручную.');
        }
    }
    return <section className="td-developer-prompt" aria-label="Готовый промпт для разработчика">
        <div className="td-prompt-actions"><button type="button" aria-expanded={open} onClick={() => { setOpen(value => !value); setManual(false); }}>{open ? 'Скрыть промпт' : 'Промпт для разработчика'}</button><button type="button" onClick={copy}>Скопировать промпт</button></div>
        {status ? <p role="status">{status}</p> : null}
        {open ? <label><span className="tc-input-label">Промпт для разработчика</span><textarea readOnly ref={input} value={text} rows={14}/></label> : null}
    </section>;
}
